function checkboxInit(): void {
  const gridboxes = document.querySelectorAll(".saved-grid .item-photo");
  for (let i = 0; i < gridboxes.length; i++) {
    gridboxes[i].addEventListener("click", (event: MouseEvent): void => {
      const target = <HTMLInputElement>event.target;
      const checkbox: HTMLInputElement = gridboxes[i].querySelector(
        "input[type=checkbox]"
      );

      if (target.tagName !== "INPUT")
        checkbox.checked = checkbox.checked != true;
    });
  }

  const formboxes = document.querySelectorAll(".checkbox-list .card");
  for (let i = 0; i < formboxes.length; i++) {
    formboxes[i].addEventListener("click", (event: MouseEvent): void => {
      const target = <HTMLInputElement>event.target;
      const checkbox: HTMLInputElement = formboxes[i].querySelector(
        "input[type=checkbox]"
      );

      if (target.tagName === "DIV" || target.tagName === "LABEL") {
        event.stopImmediatePropagation();
        event.preventDefault();
        formboxes[i].classList.toggle("bg-secondary");
        formboxes[i].classList.toggle("text-white");
        checkbox.checked = checkbox.checked != true;
      } else {
        formboxes[i].classList.toggle("bg-secondary");
        formboxes[i].classList.toggle("text-white");
      }
    });
  }
}

export default (): void => {
  document.addEventListener("DOMContentLoaded", checkboxInit);
};
